import en from './en'
import th from './th'

export default {
    en,
    th,
}
